import { Helmet } from "react-helmet-async";
import { SITE, IMAGES } from "@/data/content";

// Per-page SEO: title, description, canonical, OG/Twitter, JSON-LD structured data
export const Seo = ({
  title,
  description,
  path = "/",
  image = IMAGES.heroWater,
  schema = null,
}) => {
  const fullTitle = title
    ? `${title} | ${SITE.name}`
    : `${SITE.name}, Private Craniosacral Practice`;
  const canonical = `${SITE.url}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

// Breadcrumb JSON-LD helper
export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE.url}${it.path}`,
  })),
});

export default Seo;
